import { Badge } from "@/components/ui/badge";
import type { TopCaptain } from "@/types/api.types";

const POSITION_COLORS: Record<string, string> = {
  GK: "bg-yellow-100 text-yellow-800",
  DEF: "bg-blue-100 text-blue-800",
  MID: "bg-green-100 text-green-800",
  FWD: "bg-red-100 text-red-800",
};

export default function TopCaptainsCard({
  captains,
}: {
  captains: TopCaptain[];
}) {
  if (captains.length === 0) {
    return (
      <div className="bg-white rounded-xl border p-12 text-center text-gray-400">
        No captain data yet
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border overflow-hidden">
      <div className="px-4 py-3 bg-gray-50 border-b">
        <p className="text-sm font-semibold text-gray-700">
          🎖️ Most Selected Captains
        </p>
      </div>

      {captains.map((captain, index) => (
        <div
          key={captain.playerId}
          className="flex items-center gap-4 px-4 py-3 border-b last:border-0 hover:bg-gray-50 transition"
        >
          {/* Rank */}
          <span className="w-6 text-center text-sm font-bold text-gray-400">
            {index + 1}
          </span>

          {/* Captain C badge */}
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center text-white text-xs font-black">
            C
          </div>

          {/* Player Info */}
          <div className="flex-1">
            <p className="font-semibold text-gray-900 text-sm">
              {captain.playerName}
            </p>
            <p className="text-xs text-gray-400">{captain.nation}</p>
          </div>

          {/* Position */}
          <Badge className={`text-xs ${POSITION_COLORS[captain.position]}`}>
            {captain.position}
          </Badge>

          {/* Selected as captain count */}
          <div className="text-right text-xs text-gray-500">
            <p className="font-semibold">{captain.selectedAsCaptain}</p>
            <p className="text-gray-400">teams</p>
          </div>

          {/* Points */}
          <div className="text-right min-w-[60px]">
            <span className="text-lg font-black text-gray-900">
              {captain.points}
            </span>
            <span className="text-xs text-gray-400 ml-1">pts</span>
          </div>
        </div>
      ))}
    </div>
  );
}
